import { Fragment, FunctionComponent } from 'react';
import { Button, Card, CardContent, Divider, Typography } from '@mui/material';
import { CardCode } from '@/models/cardcodes';
import { CardListRow } from '@/components/Card/CardListRow';
import { useTranslation } from 'react-i18next';

type ActiveCodesCardProps = {
    cardCode: CardCode;
    onAddButtonClick: () => void;
};

export const ActiveCodesCard: FunctionComponent<ActiveCodesCardProps> = ({
    cardCode,
    onAddButtonClick,
}) => {
    const { t } = useTranslation();
    return (
        <Card
            sx={{
                maxWidth: '640px',
            }}
        >
            <CardContent
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Typography variant='h6'>Promotion Codes</Typography>

                <Button
                    sx={{
                        ml: 'auto',
                    }}
                    onClick={onAddButtonClick}
                    variant='contained'
                >
                    + Freigabe Codes hinzufügen
                </Button>
            </CardContent>

            <CardListRow
                sx={{
                    backgroundColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Typography sx={{ width: '50%', fontWeight: 600 }}>
                    Name
                </Typography>
                <Typography sx={{ width: '50%', fontWeight: 600 }}>
                    Verwendet
                </Typography>
            </CardListRow>

            {cardCode.singleCodes.length === 0 && (
                <CardListRow
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 500,
                        }}
                    >
                        {t('noEntriesAvailable')}
                    </Typography>
                </CardListRow>
            )}

            {cardCode.singleCodes.map(({ code, usageTimestamp }, index) => (
                <Fragment key={index}>
                    {index !== 0 && <Divider sx={{ width: '100%' }} />}

                    <CardListRow
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <Typography sx={{ width: '50%' }}>{code}</Typography>
                        <Typography sx={{ width: '50%' }}>
                            {usageTimestamp?.length ? 'Ja' : 'Nein'}
                        </Typography>
                    </CardListRow>
                </Fragment>
            ))}
        </Card>
    );
};
